<template>
    <hts-card class="h-full max-w-[300px]">
        <slot name="logo">
            <img
                :src="logo"
                alt="Freightek Logo" >
        </slot>
        <hr >

        <div v-if="!initializing">
            <div v-if="connected">
                <hts-form-button
                    :disabled="!checkPermission(layoutPermissions['connect_delete'])"
                    color="error"
                    class="w-full"
                    :loading="loading"
                    :disable="!loading"
                    @click="handleDisconnect">
                    Ngắt kết nối
                </hts-form-button>
            </div>
            <div v-else>
                <hts-form-button
                    :disabled="!checkPermission(layoutPermissions['connect_add'])"
                    color="success"
                    class="w-full"
                    :loading="loading"
                    :disable="!loading"
                    @click="requestConnect">
                    Tạo kết nối
                </hts-form-button>
            </div>
        </div>
        <div
            v-else
            v-loading="true"
            class="h-10 w-full" />
        <slot
            :connected
            :connection />
    </hts-card>
</template>

<script setup lang="ts">
import layoutPermissions from '~/data/permissions/layout-permissions'

const props = defineProps({
  app: {
    type: String,
    required: true
  },
  apis: {
    type: Object,
    required: true
  },
  logo: String,
  connectFunction: {
    type: Function
  }
})
const { logo, app, apis, connectFunction } = toRefs(props)
onMounted(() => {
  _getData()
})

const initializing = ref<boolean>(true)
const loading = ref<boolean>(false)
const connection = ref<any>(null)
const connected = computed<boolean>(() => !!connection.value)

onMounted(() => {
  _getData()
})

const _getData = () => {
  initializing.value = true

  const api = apis.value.get
  $api(api, { uriParams: { ID: app.value } })
    .then((response: any) => {
      const resData: any = response?.data?.value
      if (resData?.data?._id) {
        connection.value = resData?.data
      }
    })
    .finally(() => {
      initializing.value = false
    })
}

const loadData = $lodash.debounce(_getData, 500)
const refresh = () => {
  loadData()
}
const authOpen = async (backUrl?: string) => {
  if (connectFunction?.value) {
    loading.value = true
    const authResult = await connectFunction?.value(backUrl)
    handleConnect(authResult)
  }
}

const requestConnect = (type: string) => {
  if (!checkPermission(layoutPermissions.connect_add)) {
    return
  }
  authOpen()
}

const handleConnect = (authData: any) => {
  const body = {
    app: app.value,
    authData
  }

  const api = apis.value.create

  loading.value = true
  $api(api, { body })
    .then((data) => {
      const resData: any = data?.data?.value

      if (resData?.success) {
        process.client && $toast().success('Kết nối thành công')
        loadData()
      }
    })
    .finally(() => {
      nextTick(() => {
        loading.value = false
      })
    })
}

const handleDisconnect = (_id: string) => {
  if (!checkPermission(layoutPermissions.connect_delete)) {
    return
  }
  const api = apis.value.delete

  loading.value = true
  $api(api, { uriParams: { ID: app.value } })
    .then((data) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        connection.value = null
        process.client && $toast().success('Ngắt kết nối thành công')
        loadData()
      }
    })
    .finally(() => {
      nextTick(() => {
        loading.value = false
      })
    })
}
defineExpose({ refresh })
</script>
